import { Transfer } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { addRecommendedCourse } from "../../../api/courses";
import { addRecommendedEvent } from '../../../api/events';
import { setTargetKeys } from '../../../redux/peakList/action';
import CustomModal from "../../../hoc/CustomModal";
import PopComponent from "../../popContent";
import moment from 'moment';

const PeakList = ({ course, handleOpenModal, events }) => {
    const [modalName, setModalName] = useState("UserPop");
    const [openModal, setModalOpen] = useState(false);
    const [error, setError] = useState({});
    let Modal = PopComponent[modalName];
    const courseData = [];

    course.map(data => {
        if (moment.tz(data.date + ' ' + data.start_time, 'America/Los_Angeles')?.format('MM/DD/YYYY') === moment().tz('America/Los_Angeles').format('MM/DD/YYYY')) {
            if (moment.tz(`${moment().tz('America/Los_Angeles').format("MM/DD/YYYY")} ${data.start_time}`, "MM/DD/YYYY h:mm A", 'America/Los_Angeles')?.diff(moment().tz('America/Los_Angeles')) > 0) {
                courseData.push({
                    key: data._id,
                    title: data.name || data.title,
                    description: data.name || data.title,
                })
            }
        }
        else if (moment.tz(data.date + ' ' + data.start_time, 'America/Los_Angeles')?.diff(moment().tz('America/Los_Angeles')) > 0) {
            courseData.push({
                key: data._id,
                title: data.name || data.title,
                description: data.name || data.title,
            })
        }
        else if (!data.date) {
            courseData.push({
                key: data._id,
                title: data.name || data.title,
                description: data.name || data.title,
            })
        }
    });

    const targetKeys = useSelector(state => state.peakListReducer)
    const dispatch = useDispatch();

    const [selectedKeys, setSelectedKeys] = useState([]);

    const onChange = (nextTargetKeys, direction, moveKeys) => {
        if (direction === 'right' && targetKeys.length < 4) {
            dispatch(setTargetKeys(nextTargetKeys))
        } else if (direction === 'left') {
            dispatch(setTargetKeys(nextTargetKeys))
        }
    };

    const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
        if (sourceSelectedKeys.length <= 4 && targetKeys.length < 4 && sourceSelectedKeys.length + targetKeys.length <= 4) {
            setSelectedKeys([...targetSelectedKeys, ...sourceSelectedKeys]);
        } else if (sourceSelectedKeys.length > 4) {
            sourceSelectedKeys.pop();
        }
    };

    const handleSubmit = () => {
        if (targetKeys.length <= 4) {
            const rec = events ? addRecommendedEvent : addRecommendedCourse
            const req = {}
            if (!events) req.course_ids = [...targetKeys]
            else req.seminar_event_ids = [...targetKeys]
            rec(req).then(res => {
                if (res.data.status === 200) {
                    handlePopModal('ErrorPop', { header: "Success", body: res.data.message })
                } else {
                    handlePopModal('ErrorPop', { header: "Error", body: res.data.message })
                }
            }).catch(err => {
                handlePopModal('ErrorPop', { header: "Error", body: err.message })
            })
        } else {
            handlePopModal('ErrorPop', { header: "Error", body: "recommended course can't be more then 4" })
        }
    };

    const handlePopModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    return (
        <div className="peak_list">
            <h2 className='mb_0'>Master Classes &amp; Seminars List</h2>
            <span className='Peak_list_subtitle'>carousel</span>
            <Transfer
                dataSource={courseData}
                titles={['Source', 'Target']}
                targetKeys={targetKeys}
                selectedKeys={selectedKeys}
                onChange={onChange}
                onSelectChange={onSelectChange}
                render={item => item.title}
                showSelectAll={false}
                showSearch={true}
                oneWay={true}
            />
            <div class="form_group form_footer">
                <button onClick={() => handleOpenModal()} type="reset" class="btn btn_gray">Cancel</button>
                <button onClick={() => handleSubmit()} type="submit" class="btn btn_primary">submit</button>
            </div>
            {Modal && (
                <CustomModal className={`${modalName === 'ErrorPop' ? 'ant-modal modal skill_model' : 'modal peak_model'} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                    <Modal
                        error={error}
                        handleOpenModal={handleOpenModal}
                    />
                </CustomModal>
            )
            }
        </div>
    )
};

export default PeakList